import {
  MdDashboard,
  MdFeedback,
  MdHelpOutline,
  MdMonitor,
  MdMovieCreation,
  MdDeveloperBoard,
  MdSettingsRemote,
  MdSettings,
  MdVpnKey,
} from 'react-icons/md';

export const navItems = [
  { title: 'TV Remote Testing', link: '/', icon: MdMonitor },
  {
    title: 'AdSure',
    link: '/creative-preview',
    icon: MdMovieCreation,
  },
];

export const adminNavItems = [
  { title: 'TV Remote Testing', link: '/', icon: MdMonitor },
  {
    title: 'AdSure',
    link: '/creative-preview',
    icon: MdMovieCreation,
  },
  {
    title: 'AdSure Monitoring',
    link: '/admin/monitoring',
    icon: MdDashboard,
  },
  {
    title: 'Pod Management',
    link: '/admin/pod-management',
    icon: MdDeveloperBoard,
  },
  {
    title: 'Remote Configuration',
    link: '/admin/remote-layouts',
    icon: MdSettingsRemote,
  },
  {
    title: 'AdSlot Flows',
    link: '/admin/adslot-flows',
    icon: MdSettings,
  },
  {
    title: 'Application Credentials',
    link: '/admin/application-credentials',
    icon: MdVpnKey,
  },
  {
    title: 'User Guide Manager',
    link: '/admin/user-guide',
    icon: MdHelpOutline,
  },
  {
    title: 'User Feedback',
    link: '/admin/user-feedback',
    icon: MdFeedback,
  },
];
